"use client" // Error components must be Client Components

import SubscribeModalErrorPage from "@/app/@subscribemodal/components/SubscribeModalErrorPage"

export default function SubscribeModalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <SubscribeModalErrorPage
      error={error}
      reset={reset}
      component="SubscribeModalEnterEmailError"
    />
  )
}
